import React, { FC } from 'react';

import classNames from 'classnames';

const Link: FC<React.AnchorHTMLAttributes<HTMLAnchorElement>> = props => (
  <a {...props} className={classNames('link', props.className)} />
);

export default Link;
